import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "./modal-error.component.html",
    styleUrls: ["./modal-error.component.scss"]
})
export class ModalErrorComponent {
    public mensaje = "";

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar(mensaje: string): void {
        this.activeModal.close(mensaje);
    }
}
